import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}><path d="M2 17h20v1.5H2V17zm0-6h20v1.5H2V11zm0-6h20v1.5H2V5z" fillRule="evenodd" /></svg>);